document.addEventListener('DOMContentLoaded', function () {
    var radioButtons = document.querySelectorAll('.quick-add-form input[type="radio"]');
    var cardMediaElements = document.querySelectorAll('.card__media');

    radioButtons.forEach(function (radio) {
        radio.addEventListener('click', function () {
            var selectedValue = radio.value;

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: selectedValue,
                    quantity: 1
                })
            })
            .then(response => response.json())
            .then(data => {
                onCartUpdate();
            })
            .catch((error) => {
                console.error('Error:', error);
            });

        });
    });

    function slideOpenCart() {
        var cart = document.querySelector('.drawer'); // Adjust this selector to match your cart element
        if (cart) {
            cart.classList.add('active'); // Add a class to show or slide open the cart
            document.body.classList.add('overflow-hidden'); // Prevent body scroll when cart drawer is open
        }
    }

    function onCartUpdate() {
        fetch('/cart?section_id=cart-drawer')
            .then(response => response.text())
            .then(responseText => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');

                const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                for (const selector of selectors) {
                    const targetElement = document.querySelector(selector);
                    const sourceElement = html.querySelector(selector);
                    if (targetElement && sourceElement) {
                        targetElement.replaceWith(sourceElement);
                    }
                }

                const emptyElements = document.querySelectorAll('.drawer__inner-empty');
                const cartDrawer = document.querySelector('cart-drawer');
                const cartDrawerItems = document.querySelector('cart-drawer-items');
                const checkoutButton = document.getElementById('CartDrawer-Checkout');

                emptyElements.forEach(element => element.remove());

                const drawerHeader = document.querySelector('.drawer__header');
                if (drawerHeader) {
                    drawerHeader.style.display = 'block';
                }
    
                if (cartDrawer) {
                    cartDrawer.classList.remove('is-empty');
                }            
                
                if (cartDrawerItems) {
                    cartDrawerItems.classList.remove('is-empty');
                } 

                if (checkoutButton) {
                    checkoutButton.removeAttribute('disabled');
                }
                freeshipping();
                slideOpenCart(); // Slide open the cart after updating it
            })
            .catch(e => {
                console.error(e);
        });
    }


    cardMediaElements.forEach(function (cardMedia) {
        cardMedia.addEventListener('click', function () {
            var mediaQuery = window.matchMedia('(max-width: 1023px)');
    
            // Hide all visible quick_add_hover elements and remove 'highlight' class
            if (mediaQuery.matches) {
                document.querySelectorAll('.quick_add_hover').forEach(function (quickAdd) {
                    quickAdd.style.display = 'none';
                    quickAdd.style.pointerEvents = 'none';
                    
                    // Remove the class from all .card__heading a elements
                    var headingLinks = document.querySelectorAll('.card__heading a');
                    headingLinks.forEach(function(link) {
                        link.classList.remove('highlight');
                    });
                });
    
                // Show the quick_add_hover for the tapped card__media
                var quickAdd = cardMedia.querySelector('.quick_add_hover');
                if (quickAdd) {
                    quickAdd.style.display = 'block';
                    quickAdd.style.pointerEvents = 'auto';
    
                    // Find the nearest .card__heading a and add the 'highlight' class
                    var cardHeadingLink = cardMedia.closest('.card').querySelector('.card__heading a');
                    if (cardHeadingLink) {
                        cardHeadingLink.classList.add('highlight');
                    }
                }
            }
        });
    });
    

    function freeshipping() {
        const freeShippingElement = document.querySelector('.cart-free-shipping');
        if (freeShippingElement) {
            freeShippingElement.classList.remove('d-none');
            const totalValueElement = document.querySelector('.totals__total-value .money');
            const moneyText = totalValueElement.textContent.trim();
            
            // Extract the number using a regular expression
            const cartPrice = parseFloat(moneyText.replace(/[^0-9.-]+/g, ''));
            
            // Calculate the total price (in this case, multiplying by 100)
            const totPrice = cartPrice * 100;

            // Update the progress meter value
            const progressMeter = document.getElementById('progress_meter');
            const progressText = document.getElementById('progress_text');
            const remaText = document.querySelector(".freeship-remaining");

            progressMeter.value = totPrice;

            // Get the max value of the progress meter
            const threshold = progressMeter.max;

            // Calculate the progress percentage
            const progress = Math.min((totPrice / threshold) * 100, 100);
            progressText.textContent = Math.round(progress) + '%';
        
            const remainingAmount = (threshold - totPrice) / 100;

            if (progress < 100 ){
                remaText.textContent = '$' + remainingAmount.toFixed(2);
                document.querySelector('.not-qualified-text').style.display = 'block';
                document.querySelector('.qualified-text').style.display = 'none';
            }else{
                document.querySelector('.not-qualified-text').style.display = 'none';
                document.querySelector('.qualified-text').style.display = 'block';
            }
        }
    }
});
